import {isEmpty} from "lodash-es";

export const selectInvestigationDetailId = (state) =>
  state.investigation.investigationId;

export const selectInvestigationShortId = (state) =>
  state.investigation.short_description;

export const selectInvestigationLoading = (state) =>
  state.investigation.createInvestigationLoading;

export const selectInvestigationGraphLoading = (state) =>
  state.investigation.graphLoading;

export const selectInvestigationEventsLoading = (state) =>
  state.investigation.eventsLoading;

export const selectSnapshotLoading = (state) =>
  state.investigation.snapshotLoading;

export const selectInvestigationGraphItems = (state) =>
  state.investigation.items;

export const selectInvestigationGraphGroups = (state) =>
  state.investigation.groups;

export const selectInvestigationEvents = (state) => state.investigation.events;

export const selectInvestigationIndicators = (state) =>
  state.investigation.indicators;

export const selectInvestigationAssets = (state) => state.investigation.assets;

export const selectInvestigationObservables = (state) =>
  state.investigation.observables;

export const selectHasInvestigation = (state) =>
  Boolean(state.investigation.investigationId);

export const selectInvestigationHasMoreResults = (state) =>
  state.investigation.hasMoreResults;

export const selectIncidentNotFound = (state) => state.investigation.notFound;

export const selectInvestigationGraphInitialized = (state) =>
  state.investigation.graphInitialized;

export const selectHasGraphItems = (state) =>
  !isEmpty(state.investigation.items);

export const selectInvestigationStatus = (state) => ({
  pendingCount: state.investigation.pendingCount,
  completedCount: state.investigation.completedCount,
  sightingCount: state.investigation.sightingCount,
  verdictsCount: state.investigation.verdictsCount,
  indicatorsCount: state.investigation.indicatorsCount,
  isComplete: state.investigation.isComplete
});

export const selectAllowSaveInvestigation = (state) =>
  !state.investigation.graphLoading &&
  !state.investigation.eventsLoading &&
  !state.investigation.isSaving &&
  state.investigation.isComplete;
